import { render, staticRenderFns } from "./healthIndex.vue?vue&type=template&id=5092ecf4&scoped=true"
import script from "./healthIndex.vue?vue&type=script&lang=js"
export * from "./healthIndex.vue?vue&type=script&lang=js"
import style0 from "./healthIndex.vue?vue&type=style&index=0&id=5092ecf4&prod&lang=css"
import style1 from "./healthIndex.vue?vue&type=style&index=1&id=5092ecf4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092ecf4",
  null
  
)

export default component.exports